var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loader',{staticClass:"mb20",attrs:{"show":_vm.showLoader,"center":false}}),(_vm.showLoader)?_c('p',[_vm._v(_vm._s(_vm.$t("authing")))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }